<template>
  <main class="main promotion_detail_kt" role="main">
    <div class="main_con">
      <div class="p_top">
        <img
          :src="
            require(`@/assets/front/images/internet_commerce/img_promotion_01.png`)
          "
        />
      </div>
      <div class="p_item_list">
        <ul>
          <li
            v-for="(item, index) in internetInfo"
            :key="index"
            :class="{ on: index == internetInfoSel }"
            @click="internetItemSel(index)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="p_item_info">
        <img
          :src="
            require(`@/assets/front/images/internet_commerce/img_promotion_02.png`)
          "
        />
      </div>
      <div class="">
        <img
          :src="
            require(`@/assets/front/images/internet_commerce/img_promotion_03.png`)
          "
        />
      </div>
      <div class="">
        <img
          :src="
            require(`@/assets/front/images/internet_commerce/img_promotion_04.png`)
          "
        />
      </div>
    </div>
    <div class="btm_info">
      <div class="txt_1">상담을 받고 싶은 상품을 선택해 주세요!</div>
      <div class="txt_2">신규/통신사 변경만 가능합니다.</div>
      <div class="radio_box">
        <div class="radio" v-for="(item, index) in internetInfo" :key="index">
          <input
            type="radio"
            :id="`radio_${index}`"
            v-model="itemSel"
            :value="item.item"
          />
          <label
            :for="`radio_${index}`"
            :title="item.item"
            @click="internetItemSel(index)"
            >{{ item.name }}</label
          >
        </div>
      </div>
    </div>
    <div class="btm_btn" @click="internetCommerceChat">
      <div class="btn_wrap">
        <button class="btn">
          상담 시작하기 >
        </button>
      </div>
    </div>
    <SafeServiceModal
      ref="safeServiceModal"
      @close="closeSafeServiceModal"
      @agreeChat="agreeChat"
    ></SafeServiceModal>
  </main>
</template>
<script>
import {
  sleep,
  nativeEnableBackKey,
  nativeDisableBackKey,
  sdk_logEvent,
  sdk_logEventKakao,
  setShopProfile,
} from '@common/lib/common/utils';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import SafeServiceModal from '@/front/customer/views/internetCommerce/modal/SafeServiceModal';

export default {
  name: 'InternetCommerce.PromotionDetailKt',
  components: {
    SafeServiceModal,
  },
  data() {
    return {
      internetInfo: [
        {
          telecomId: 'KT',
          item: '100M+TV',
          name: '100M+TV',
        },
        {
          telecomId: 'KT',
          item: '500M+TV',
          name: '500M+TV',
        },
        {
          telecomId: 'KT',
          item: '100M',
          name: '100M단품',
        },
      ],
      internetInfoSel: 2, // key
      itemSel: '500M+TV', // value
      leftVal: 0,
    };
  },
  async created() {
    // alert(this.$route.params.type); // 100M, 500M+TV
    this.itemSel = this.$route.params.type || '500M+TV';
    this.setInternetList();
    await this.fetchMe();
  },
  async mounted() {
    await this.internetItemSel(this.internetInfoSel);
  },
  updated() {},
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    ...internetMapActions([
      internetTypes.UPDATE_INTERNET_COMMERCE_PROMOTION_CHAT,
    ]),
    async fetchMe() {
      await this[userTypes.FETCH_ME]();
      console.log('this.userthis.userthis.user');
      console.log(this.user);
    },
    async internetItemSel(index) {
      var itemInfoImg = document.querySelector('.p_item_info img');
      var promotionDetailKt = document.querySelector('.promotion_detail_kt');
      var leftVal = 0;

      console.log('indexindexindexindexindex');
      console.log(itemInfoImg);
      console.log(promotionDetailKt);
      console.log(index);

      if (index == 0) {
        this.leftVal = 0;
        console.log('index0 = 0');
      } else if (index == 1) {
        this.leftVal =
          itemInfoImg.offsetWidth / 2 - promotionDetailKt.offsetWidth / 2;
        console.log('index1 = ' + this.leftVal);
      } else if (index == 2) {
        this.leftVal = itemInfoImg.offsetWidth;
        console.log('index2 = ' + this.leftVal);
      }
      console.log(this.leftVal);
      this.internetInfoSel = index;
      this.itemSel = this.internetInfo[index].item;

      await this.imagePosition();
    },
    async imagePosition() {
      var itemInfo = document.querySelector('.p_item_info');
      console.log('222222 = ' + this.leftVal);
      setTimeout(() => {
        itemInfo.scroll({
          behavior: 'smooth',
          left: this.leftVal,
        });
      }, 300);
    },
    async setInternetList() {
      if (this.itemSel == '100M+TV') {
        this.internetInfoSel = 0;
      } else if (this.itemSel == '500M+TV') {
        this.internetInfoSel = 1;
      } else if (this.itemSel == '100M') {
        this.internetInfoSel = 2;
      }
    },
    async internetCommerceChat() {
      this.$refs.safeServiceModal.promotion = 'KT';
      this.$refs.safeServiceModal.isOpen = true;
    },
    closeSafeServiceModal() {
      this.$refs.safeServiceModal.isOpen = false;
    },
    async agreeChat() {
      // alert(this.itemSel);
      const params = { item: this.itemSel.replace('+', '') };
      this[internetTypes.UPDATE_INTERNET_COMMERCE_PROMOTION_CHAT](params).then(
        res => {
          sdk_logEvent('INTERNET_PROMOTION_CHAT', {
            promotionCode: 'KT2408',
            user_id: this.user.id,
            user_nickname: this.user.nickname,
            telecom: 'KT',
            item: this.itemSel,
          });

          sdk_logEventKakao('INTERNET_PROMOTION_KT_CHAT');

          const chatParams = {};
          chatParams.uuid = res;

          this.$router.push({
            name: 'chat.room',
            params: chatParams,
          });
        },
      );
    },
  },
};
</script>
